// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class UnsubscribeRequestModel {
    'accountId': number;
    'email': string;
    'userId': number;
    'username': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof UnsubscribeRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "email",
            "baseName": "email",
            "type":     "string"
        },
        {
            "name":     "userId",
            "baseName": "userId",
            "type":     "number"
        },
        {
            "name":     "username",
            "baseName": "username",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return UnsubscribeRequestModel.attributeTypeMap;
    }
}
